import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { GrowthbookFlagsEnum } from 'growthbook/types'
import { useMemo } from 'react'
import useUser from 'shared/hooks/use-user'
import { AutomationRuleActionsEnum } from '../enums/action-enum'

export const useAllowedActions = (): AutomationRuleActionsEnum[] => {
  const { isRootAdmin, isWhiteLabelOwner } = useUser()
  const whiteLabelFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.WhiteLabel)

  const data = useMemo(() => {
    return Object.values(AutomationRuleActionsEnum).filter(action => {
      switch (action) {
        case AutomationRuleActionsEnum.create_user:
          return isRootAdmin
        case AutomationRuleActionsEnum.create_white_label_user:
          if (!whiteLabelFeatureIsOn) return false
          return isWhiteLabelOwner
        default:
          return true
      }
    })
  }, [isRootAdmin, whiteLabelFeatureIsOn, isWhiteLabelOwner])

  return data
}
